<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <div class="personal-details">
          <h4 class="personal-details-title">Material Charge List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Charge Name</th>
                <th scope="col">UOM</th>
                <th scope="col">Quantity</th>
                <th scope="col">Price</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of materialChargeData | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th scope="col">{{product.chargeName}}</th>
                <th scope="col">{{product.uom}}</th>
                <th scope="col">{{product.qty}}</th>
                <th scope="col">{{product.price}}</th>
                <!-- <th>
                  <svg xmlns="http://www.w3.org/2000/svg" (click)="getProductCompositionById(product.productCompositionId)" data-toggle="modal" data-target="#exampleModalView"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                  </svg> 
                </th> -->
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="materialChargeData.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
</div>


<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Prodcut Composition
          <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let product of singleMaterialChargeData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Name</label>
                <input type="text" readonly value="{{product.productName}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Total Amount</label>
                <input type="text" readonly value="{{product.totalAmount}}" class="form-control">
              </div>
            </div>
          </div>
          <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
            <thead>
              <tr>
                <th style="width: 70%;">Product</th>
                <th style="width: 10%;text-align: center;">Price</th>
                <th style="width: 10%;text-align: center;">Quantity</th>
                <th style="width: 10%;text-align: center;">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let productCompositionIngList of product.productCompositionIngList;let i = index">
                <th>{{productCompositionIngList.name}}</th>
                <th style="text-align: center;">{{productCompositionIngList.price}}</th>
                <th style="text-align: center;">{{productCompositionIngList.qty}}</th>
                <th style="text-align: center;">{{productCompositionIngList.price * productCompositionIngList.qty}}</th>
              </tr>    
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>